var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"celebrate"},_vm._l((_vm.count),function(n){return _c('f7-icon',{key:n,ref:"icons",refInFor:true,attrs:{"f7":_vm.icon,"color":"theme"}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }